import { Select } from 'antd';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getAllCitiesWithoutSearch } from 'redux/reducer/basicData/allCitiesWithoutSearch';
import { RootState, store } from 'redux/store';
const { Option } = Select;

interface IProps {
  provinceId?: number;
  cityId?: number;
  isFromPersonAddress?: boolean;
  getFullData?: (_data: any) => void;
  getCityValue?: (_id: number) => void;
}

const TcInputCity: FC<IProps> = ({ getFullData, getCityValue, provinceId, isFromPersonAddress = false, ...props }) => {
  const allCitiesWithoutSearch = useSelector((state: RootState) => state.city.allCitiesWithoutSearch);

  useEffect(() => {
    !allCitiesWithoutSearch && store.dispatch(getAllCitiesWithoutSearch());
  }, []);

  const onSelect = (id: number) => {
    getCityValue && getCityValue(id);
    getFullData && getFullData(allCitiesWithoutSearch?.find((item) => item.id === id));
  };

  return (
    <Select
      {...props}
      onSelect={onSelect}
      showSearch
      allowClear
      placeholder='انتخاب کنید'
      optionFilterProp='children'
      filterOption={(input, option) => (option?.children as unknown as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
      {allCitiesWithoutSearch?.map((item) => {
        if (provinceId && item.provinceId !== provinceId) return null;
        return (
          <Option key={item.id} value={isFromPersonAddress ? [item.title, item.id] : item.id}>
            {item.title}
          </Option>
        );
      })}
    </Select>
  );
};

export default TcInputCity;
